import { IconButton, TextField, Tooltip } from "@mui/material";
import moment from "moment";
import React from "react";
import {
  ColContentCommentLeft,
  ColContentCommentProfile,
  ColContentCommentRight,
  ContentCommentProfile,
  ContentDate,
  ContentIcons,
  ContentText,
  ContentUser,
  ImgProfile,
  RowComments,
} from "./CommentsCases.styled";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CancelIcon from "@mui/icons-material/Cancel";
import SaveIcon from "@mui/icons-material/Save";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import ThumbUpOffAltIcon from "@mui/icons-material/ThumbUpOffAlt";
import isOwnerProfile from "../../assets/svg/isowner-profile.svg";
import isOtherOwnerProfile from "../../assets/svg/isotherowner-profile.svg";
import { theme as themeConfig } from "../../themes/themes";

const CommentsCases = (props) => {
  return (
    <RowComments isOwnerCase={props.item.isOwnerCase}>
      {props.item.isOwnerCase ? (
        <>
          <ColContentCommentLeft>
            <ContentIcons>
              {!props.isEditComment && (
                <>
                  <Tooltip title={"Delete"}>
                    <IconButton
                      onClick={() => props.handleDeleteComment(props.item)}
                    >
                      <DeleteForeverIcon style={{ color: themeConfig.text.primary }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Edit"}>
                    <IconButton
                      onClick={() => props.handleEditComment(props.item)}
                    >
                      <EditIcon style={{ color: themeConfig.text.primary }} />
                    </IconButton>
                  </Tooltip>
                  <ContentDate idCaseComment={props.item.idCaseComment}>
                    {moment(props.item.createDate).format("ll")}
                  </ContentDate>
                </>
              )}
              {props.isEditComment && (
                <>
                  <Tooltip title={"Save"}>
                    <IconButton
                      onClick={() =>
                        props.handleUpdateComment(
                          props.commentData,
                          props.item.smiley,
                          props.item.ilike
                        )
                      }
                    >
                      <SaveIcon style={{ color: themeConfig.text.primary }} />
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Cancel"}>
                    <IconButton
                      onClick={() => props.handleCancelUpdateComment()}
                    >
                      <CancelIcon style={{ color: themeConfig.text.primary }} />
                    </IconButton>
                  </Tooltip>
                  <ContentDate idCaseComment={props.item.idCaseComment}>
                    {moment(props.item.createDate).format("ll")}
                  </ContentDate>
                </>
              )}
            </ContentIcons>
            {props.isEditComment &&
              props.item.idCaseComment === props.commentData.idCaseComment ? (
              <TextField
                id="comment-description"
                variant="standard"
                placeholder="Type your comment"
                defaultValue={props.item.comment}
                onChange={(e) => props.handleChangeInputEdit(e, props.item)}
              />
            ) : (
              <ContentText>{props.item.comment}</ContentText>
            )}
            <ContentIcons>
              {!props.isEditComment && (
                <>
                  <Tooltip title={"Smiley"}>
                    <IconButton
                      onClick={() =>
                        props.handleUpdateComment(
                          props.item,
                          props.item.smiley === "true" ? false : true,
                          props.item.ilike
                        )
                      }
                    >
                      {props.item.smiley === "true" ? (
                        <SentimentSatisfiedAltIcon />
                      ) : (
                        <SentimentSatisfiedAltIcon
                          style={{ color: themeConfig.neutral.gray[1200] }}
                        />
                      )}
                    </IconButton>
                  </Tooltip>
                  <Tooltip title={"Like"}>
                    <IconButton
                      onClick={() =>
                        props.handleUpdateComment(
                          props.item,
                          props.item.smiley,
                          props.item.ilike === "true" ? false : true
                        )
                      }
                    >
                      {props.item.ilike === "true" ? (
                        <ThumbUpOffAltIcon />
                      ) : (
                        <ThumbUpOffAltIcon style={{ color: themeConfig.neutral.gray[1200] }} />
                      )}
                    </IconButton>
                  </Tooltip>
                  <ContentUser idCaseComment={props.item.idCaseComment}>
                    User ID: {props.item?.createUserInfo?.ccmsuser}
                  </ContentUser>
                </>
              )}
            </ContentIcons>
            {props.isEditComment && (
              <ContentUser>User ID: {props.item.createUser}</ContentUser>
            )}
          </ColContentCommentLeft>
          <ColContentCommentProfile>
            <ContentCommentProfile idCaseComment={props.item.idCaseComment}>
              <ImgProfile src={isOwnerProfile} alt="" />
            </ContentCommentProfile>
          </ColContentCommentProfile>
        </>
      ) : (
        <>
          <ColContentCommentProfile>
            <ContentCommentProfile>
              <ImgProfile src={isOtherOwnerProfile} alt="" />
            </ContentCommentProfile>
          </ColContentCommentProfile>
          <ColContentCommentRight>
            <ContentDate>
              {moment(props.item.createDate).format("ll")}
            </ContentDate>
            <ContentText>{props.item.comment}</ContentText>
            <ContentUser>User ID: {props.item.createUser}</ContentUser>
          </ColContentCommentRight>
        </>
      )}
    </RowComments>
  );
};

export default CommentsCases;
